var skinArray = new Array();
skinArray[0] = "white";
skinArray[1] = "ivory";
skinArray[2] = "beige";
skinArray[3] = "lightbrown";
skinArray[4] = "medbrown";
skinArray[5] = "darkbrownblack";

var hairArray = new Array();
hairArray[0] = "blonde";
hairArray[1] = "whitegrey";
hairArray[2] = "red";
hairArray[3] = "lightbrown";
hairArray[4] = "medbrown";
hairArray[5] = "darkbrown";
hairArray[6] = "black";



var test1 = 0;
var test2 = 0;

  let proname = "";
let dyproname = "";


function skinOver(div1,div2){
for(i=1;i<=div2;++i){
if(i==div1){
	$('#skintone_img'+i).attr('src','https://cdn.shopify.com/s/files/1/0550/6623/0861/files/hair_stage_'+i+'_over.jpg');
	}
	else{
	$('#skintone_img'+i).attr('src','https://cdn.shopify.com/s/files/1/0550/6623/0861/files/hair_stage_'+i+'.jpg');	
	}
}
	
}
function skinOut(div1,div2){
	$('#skintone_img'+div1).attr('src','https://cdn.shopify.com/s/files/1/0550/6623/0861/files/hair_stage_'+div1+'.jpg');
}


function skinClick(div1,div2){
    dyproname = $(".skintone-selection").attr("data-protitle");
  proname = $(".skintone-selection").attr("data-protitle");
  if(dyproname == "Hair Removal Device IPL-S" || dyproname == "Hair Removal Device IPL"){
    proname = "Tria IPL";
  }
  console.log(proname+"||"+dyproname);
for(i=1;i<=div2;++i){
if(i==div1){
	
	$('#skintone_img'+i+'_click').attr('src','https://cdn.shopify.com/s/files/1/0550/6623/0861/files/hair_stage_'+i+'_click.jpg');
	$('#skintone_img'+i+'_click').css('display','block');
	$('#skintone_img'+i).css('display','none');
	
	}
else{
	$('#skintone_img'+i+'_click').css('display','none');
	$('#skintone_img'+i).css('display','block');
}
}
test1 = div1;
if (test1 != 0 && test2 != 0) {

  
	$color =  $("#selectedColorProduct").text().split('-');
	if (test2<4) {$('#second_select').html('<div class="clearfix"><h3 class="red-color col-sm-2 pull-left">No! </h3><div class="pull-left  col-sm-10"><p class="p-larger text-left m-top-10">'+proname+' works only on brown or black body hair.</p></div><div class="clearfix"></div> </div>');
	//oTB_CPwrapGAS.onUXerrorEvent('Skin Tone or Hair Color', 'The Tria Laser 4X works only on brown or black body hair.');
                  $(".probuybtn").hide();
	}
	else if (test1>4) {
      $('#second_select').html('<div class="clearfix"><h3 class="red-color col-sm-2 pull-left">No! </h3><div class="pull-left  col-sm-10"><p class="p-larger text-left m-top-10">'+proname+' works only on brown or black body hair.</p></div><div class="clearfix"></div> </div><div class="p-smaller m-top-10">People with dark skin tones have a higher risk of skin injury with the '+proname+' because of higher levels of melanin in the skin. Melanin is the pigment that gives skin its beautiful brown coloring.</div></div>');
       $(".probuybtn").hide();                
      }
	else {
      $('#second_select').html('<div class="clearfix proactwrap"><h3 class="cyan-color col-sm-2 pull-left">Yes! </h3><div class="pull-left  col-sm-9"><p class="p-larger text-center m-top-10">Our '+proname+' works for you!</p></div><div class="prowact"><input type="submit" class="proceed-btn btn" id="proceed_activation" value="NEXT" border="0" /></div></div></div><br />');
      $(".probuybtn").show();
    }
}

	 div1 -= 1;	
	 var send_color = skinArray[div1];
	// _gaq.push(['_trackEvent', 'apps', 'select_skin', send_color]);
	//oTB_CPwrapGAS.onAppClick('apps', 'select_skin', send_color);

}


function skinOver2(div1,div2){
for(i=1;i<=div2;++i){
if(i==div1){

	$('#skintone2_img'+i).attr('src','https://cdn.shopify.com/s/files/1/0550/6623/0861/files/hair2_stage_'+i+'_over.jpg');
	}
	else{
	$('#skintone2_img'+i).attr('src','https://cdn.shopify.com/s/files/1/0550/6623/0861/files/hair2_stage_'+i+'.jpg');	
	}
}
	
}
function skinOut2(div1,div2){
	$('#skintone2_img'+div1).attr('src','https://cdn.shopify.com/s/files/1/0550/6623/0861/files/hair2_stage_'+div1+'.jpg');
}

function skinClick2(div1,div2){
for(i=1;i<=div2;++i){
if(i==div1){
	$('#skintone2_img'+i+'_click').attr('src','https://cdn.shopify.com/s/files/1/0550/6623/0861/files/hair2_stage_'+i+'_click.jpg');
	$('#skintone2_img'+i+'_click').css('display','block');
	$('#skintone2_img'+i).css('display','none');
	
	}
else{
	$('#skintone2_img'+i+'_click').css('display','none');
	$('#skintone2_img'+i).css('display','block');
}
	
}
test2 = div1;
if (test1 != 0 && test2 != 0) {
	$color =  $("#selectedColorProduct").text().split('-');;
	if (test2<4) {$('#second_select').html('<div class="clearfix"><h3 class="red-color col-sm-2 pull-left">No! </h3><div class="pull-left  col-sm-10"><p class="p-larger text-left m-top-10">'+proname+' works only on brown or black body hair.</p></div><div class="clearfix"></div> </div>');
	//oTB_CPwrapGAS.onUXerrorEvent('Skin Tone or Hair Color', 'The Tria Laser 4X works only on brown or black body hair.');
                  $(".probuybtn").hide();
	}
	else if (test1>4) {
      $('#second_select').html('<div class="clearfix"><h3 class="red-color col-sm-2 pull-left">No! </h3><div class="pull-left  col-sm-10"><p class="p-larger text-left m-top-10">'+proname+' works only on brown or black body hair.</p></div><div class="clearfix"></div> </div><div class="m-top-10 p-smaller">People with dark skin tones have a higher risk of skin injury with the '+proname+' because of higher levels of melanin in the skin. Melanin is the pigment that gives skin its beautiful brown coloring.</div></div>');
     $(".probuybtn").hide();
    }
	else {$('#second_select').html('<div class="clearfix proactwrap"><h3 class="cyan-color col-sm-2 pull-left">Yes! </h3><div class="pull-left  col-sm-9"><p class="p-larger text-center m-top-10">Our '+proname+' works for you!</p></div><div class="prowact"><input type="submit" class="proceed-btn btn" id="proceed_activation" value="NEXT" border="0" /></div></div></div><br />');
         $(".probuybtn").show();
         }}
	
	 div1 -= 1;	
	 var send_color = hairArray[div1];
	// _gaq.push(['_trackEvent', 'apps', 'select_hair', send_color]);
	//oTB_CPwrapGAS.onAppClick('apps', 'select_hair', send_color);

}